module.exports = __webpack_public_path__ + "static/media/LPIC-3-legacy-Core.d431a87d.jpg";